import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import DuplicateDashboardClient from 'use-case/dashboard/duplicate/duplicateDashboardClient';
import DuplicateDashboardCriteria from 'use-case/dashboard/duplicate/duplicateDashboardCriteria';
import { asDashboard } from 'adapter/out/client/dashboard/mappers/dashboard';

export default (httpClient: httpClientFunction, baseUrl: string): DuplicateDashboardClient => (criteria: DuplicateDashboardCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.id}/duplicate`, {
        method: 'POST',
        body: JSON.stringify({ name: criteria.name }),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asDashboard)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));
